import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

// The backend serialises with JsonNamingPolicy.SnakeCaseLower, so the wire
// shape is snake_case. Mirror the adaptPersonDetail.ts pattern and convert
// at the edge so the rest of the app deals in camelCase only.
interface DeviceTokenWireShape {
	id: number;
	platform: string;
	created_at: string;
	updated_at: string | null;
}

const adaptDevice = (wire: DeviceTokenWireShape): AdminDeviceTokenResponse => ({
	id: wire.id,
	platform: wire.platform,
	createdAt: wire.created_at,
	updatedAt: wire.updated_at
});

const fetchUserDevices = async (
	userId: string
): Promise<AdminDeviceTokenResponse[]> => {
	const response = await cmsClient.get<DeviceTokenWireShape[]>(
		`/homepage/admin/store/user/${userId}/devices/`
	);
	return response.data.map(adaptDevice);
};

const useUserDevices = (userId: string) => {
	return useQuery(["user-devices", userId], () => fetchUserDevices(userId), {
		enabled: !!userId
	});
};

export default useUserDevices;
